module.exports = __webpack_public_path__ + "assets/img/roletext-9cc7c928.png";